import * as THREE from 'three'

/**
 * Mouse-button scheme for the editor viewport's drei OrbitControls — used in
 * edit mode and in live's rig-less fallback (the two views OrbitControls owns;
 * see Scene.jsx). One deliberate departure from OrbitControls' defaults:
 *
 *   LEFT   -> orbit   (plain drag; Alt+LEFT also orbits — Alt isn't a modifier
 *                      OrbitControls special-cases. Shift/Ctrl+LEFT pan, its
 *                      built-in.)
 *   MIDDLE -> pan     (Unreal/Blender convention)
 *   RIGHT  -> DISABLED
 *   wheel  -> zoom    (enableZoom, unchanged)
 *
 * The RIGHT button is unbound ON PURPOSE. Browser- and extension-level
 * mouse-gesture software (Vivaldi/Opera rocker gestures, CrxMouse, and others)
 * turns a right-button drag-and-release into Back / Forward / open-new-tab, and
 * a web page cannot reliably suppress that — preventDefault on `contextmenu`
 * stops only the native menu, not the gesture engine sitting above the page. So
 * the fix is not to fight the browser but to stop asking the user to hold the
 * right button for the camera at all; pan moves to the middle button.
 *
 * -1 is OrbitControls' no-op sentinel: its onMouseDown switch has cases only for
 * MOUSE.ROTATE / DOLLY / PAN and falls through to an empty default for anything
 * else, so the right button starts no camera action. (OrbitControls only ever
 * reads mouseButtons at pointer-down, so this object may also be mutated live.)
 */
export const EDITOR_MOUSE_BUTTONS = Object.freeze({
  LEFT: THREE.MOUSE.ROTATE,
  MIDDLE: THREE.MOUSE.PAN,
  RIGHT: -1,
})
